import React from "react";
import { FxmsData } from "../fxms/datas/FxData";
import { EngInfo } from "./EngInfo";

import "./../css/VUP_dash.css";

export const ComplexEng = (props) => {
  const { complexInloNo, tmpInloList } = props;

  let energy = FxmsData.getDatas("energy");
  const isNoAirComplex = String(complexInloNo) === "14000";

  const complexInloName = tmpInloList.find(item => item.complexInloNo === complexInloNo).inloName;

  return (
    <div className={`dataBoxGroup ${isNoAirComplex ? "twoColumn" : ""}`}>
      {!isNoAirComplex && (
        <div className="dataBox">
          <EngInfo
          complexInloNo={complexInloNo}
          complexInloName={complexInloName}
          energy={energy}
          engId={"AIR"}
          />
        </div>
      )}
      <div className="dataBox">
        <EngInfo
        complexInloNo={complexInloNo}
        complexInloName={complexInloName}
        energy={energy}
        engId={"STEAM"}
        />
      </div>
      <div className="dataBox">
        <EngInfo
        complexInloNo={complexInloNo}
        complexInloName={complexInloName}
        energy={energy}
        engId={"EPWR"}
        />
      </div>
    </div>
  )
}
